import { render, staticRenderFns } from "./mobileView.vue?vue&type=template&id=2115d3b6&scoped=true&"
import script from "./mobileView.vue?vue&type=script&lang=js&"
export * from "./mobileView.vue?vue&type=script&lang=js&"
import style0 from "./mobileView.vue?vue&type=style&index=0&id=2115d3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115d3b6",
  null
  
)

export default component.exports